import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { MasterService } from '../@core/services/master.service';
import { RoleService } from '../@core/services/role.service';
import { NbToastrService } from '@nebular/theme';
import { MenuService } from '../pages/pages-menu';
import { AppKeycloakService } from '../services/keycloak.service';
// import { AppKeycloakService } from '../services/keycloak.service';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  form: FormGroup;
  // userId = 'test@mail.com';
  // password = 'test@123';
  // role = 'Bangalore';
  // unitData: any;
  showPassword: boolean = true;
  isSoucringAvailable = true;
  userDetails: any[] = [];
  getAllUsersData: string[] = [];
  managersList = [];

  // Hardcoded credentials
  //  private readonly correctEmail = 'test@mail.com';
  //  private readonly correctPassword = 'test@123';
  //  private readonly correctRole: 'Manager' | 'Engineer';
  // isSoucringAvailable = false;
  unitData = [
    { id: 'Engineer', unitName: 'Engineer' },
    { id: 'Manager', unitName: 'Manager' },
    { id: 'Admin', unitName: 'Admin' }

  ]

  constructor(private router: Router,
    private f_builder: FormBuilder,
    private authService: AuthService,
    private masterService: MasterService,
    private roleService: RoleService,
    private notify: NbToastrService,
    private menuService: MenuService,
    private ks:AppKeycloakService
    // private notify: NotificationService,
    // private masterDataSerive: MasterDataService,
    // private authService: AuthService,
    // private masterDataService: MasterDataService,
  ) { }

 


  ngOnInit(): void {
    this.form = this.f_builder.group({
      // username: ['rama', Validators.required],
      // password: ['rama@123', Validators.required],
      // role: ['Manager', Validators.required]

      // username: ['shiva', Validators.required],
      // password: ['shiva@123', Validators.required],
      // role: ['Engineer', Validators.required]

      // username: ['Admin', Validators.required],
      // password: ['admin@123', Validators.required],
      // role: ['Admin', Validators.required]

      username: ['', Validators.required],
      password: ['', Validators.required],
      role: ['']

    });
    this.form.get('role').valueChanges.subscribe(() => {
      this.clearErrorMessage();
    });

    this.form.get('username').valueChanges.subscribe(() => {
      this.clearErrorMessage();
    });

    this.form.get('password').valueChanges.subscribe(() => {
      this.clearErrorMessage();
    });
    // this.masterDataService.getAllUnits().subscribe((result: any) => {
    //   this.unitData = result['data'];
    // });
  }
  clearErrorMessage(): void {
    this.loginError = ''; // Clear the error message
  }

  // signUp() {
  //   debugger
  //   // Check if form is valid
  //   if (this.form.invalid) {
  //     alert('Please fill in all fields correctly.');
  //     return;
  //   }

  //   const { username, password, role } = this.form.value;

  //   // Check if the credentials match
  //   if (username === this.correctEmail && password === this.correctPassword && (role === 'Manager' || role === 'Engineer')) {
  //     // Redirect to dashboard page
  //     // this.router.navigate(['/dashboard']); // Update this route to match your actual dashboard route
  //     if(role === 'Manager') {
  //       this.router.navigate(['/dashboard-manager']);
  //       sessionStorage.setItem('role', role);
  //     }
  //     else if(role === 'Engineer') {
  //       this.router.navigate(['/dashboard-engineer']); 
  //       sessionStorage.setItem('role', role);
  //     }
  //   } else {
  //     // Optionally show an error message if credentials are incorrect
  //     alert('Invalid credentials. Please try again.');
  //   }
  // }
  loginError: string = '';

  // signUp() {
  //   debugger;

  //   // Check if the form is valid
  //   if (this.form.invalid) {
  //     alert('Please fill in all fields correctly.');
  //     return;
  //   }

  //   const username = this.form.get('username').value;
  //   const password = this.form.get('password').value;
  //   const role= this.form.get('role').value;

  //   // Prepare the payload for the API call
  //   const payload = { username, password, role };

  //   // Call the login API
  // //   this.masterService.login(username, password, role).subscribe({
  // //     next: (res) => {
  // //       const { status, message , user_id} = res;

  // //       if (status === 'success') {
  // //         alert('Login successful!');
  // // debugger;
  // //         // Redirect to the appropriate dashboard based on the role
  // //         if (role === 'Manager') {
  // //           this.router.navigate(['/dashboard-manager']);
  // //         } else if (role === 'Engineer') {
  // //           this.router.navigate(['/dashboard-engineer']);
  // //         }

  // //         // Save the role to session storage
  // //         sessionStorage.setItem('role', role);
  // //         sessionStorage.setItem('user_id', res.data[0].result.user_id);
  // //       } else {
  // //         // Display a custom error message if login fails
  // //         alert(message || 'Invalid credentials. Please try again.');
  // //       }
  // //     },
  // //     error: (err) => {
  // //       console.error('An error occurred during login:', err);
  // //       alert('An error occurred while logging in. Please try again.');
  // //     }
  // //   });
  // this.masterService.login(username, password, role).subscribe({
  //   next: (res) => {
  //     if (res?.status === 'success' && res?.data?.length > 0) {
  //       try {
  //         // Parse the result string into an object
  //         const result = JSON.parse(res.data[0].result);

  //         if (result.status === 'Success') {
  //           // alert(result.message || 'Login successful!');
  //           console.log(result.message || 'Login successful!');

  //           // Save the role and user_id to session storage
  //           sessionStorage.setItem('role', role);
  //           sessionStorage.setItem('user_id', result.user_id);

  //           // Redirect to the appropriate dashboard
  //           if (role === 'Manager') {
  //             this.router.navigate(['/dashboard-manager']);
  //           } else if (role === 'Engineer') {
  //             this.router.navigate(['/dashboard-engineer']);
  //           }
  //         } else {
  //           alert(result.message || 'Invalid credentials. Please try again.');
  //         }
  //       } catch (error) {
  //         console.error('Error parsing response:', error);
  //         alert('An error occurred while processing the response.');
  //       }
  //     } else {
  //       alert('Invalid response from the server.');
  //     }
  //   },
  //   error: (err) => {
  //     console.error('An error occurred during login:', err);
  //     alert('An error occurred while logging in. Please try again.');
  //   }
  // });

  // }

  // signUp() {
  //   // const role = this.roleService.getUserRole();
  //   if (this.form.invalid) {
  //     this.loginError = 'Please fill in all fields correctly.';
  //     return;
  //   }

  //   const username = this.form.get('username').value;
  //   const password = this.form.get('password').value;
  //   const role = this.form.get('role').value;

  //   const payload = { username, password, role };

  //   this.masterService.login(username, password, role).subscribe({
  //     next: (res) => {
  //       if (res?.status === 'success' && res?.data?.length > 0) {
  //         try {
  //           const result = JSON.parse(res.data[0].result);
  //           debugger;
  //           if (result.status === 'Success') {
  //             sessionStorage.setItem('role', role);
  //             sessionStorage.setItem('user_id', result.user_id);
  //             setTimeout(()=> {
  //               console.log(result.message || 'Login successful!');
  //               if (role === 'Manager') {
  //                 this.router.navigate(['/dashboard-manager']);
  //               } else if (role === 'Engineer') {
  //                 this.router.navigate(['/dashboard-engineer']);
  //               } else if (role === 'Admin') {
  //                 this.router.navigate(['/dashboard-manager']);
  //               }
  //             }, 1000)
  //           } else {
  //             this.loginError = result.message || 'Invalid credentials. Please try again.';
  //           }
  //         } catch (error) {
  //           console.error('Error parsing response:', error);
  //           this.loginError = 'An error occurred while processing the response.';
  //         }
  //       } else {
  //         this.loginError = 'Invalid response from the server.';
  //       }
  //     },
  //     error: (err) => {
  //       console.error('An error occurred during login:', err);
  //       this.loginError = 'An error occurred while logging in. Please try again.';
  //     },
  //   });
  // }

  // signUp() {
  //   if (this.form.invalid) {
  //     this.loginError = 'Please fill in all fields correctly.';
  //     return;
  //   }

  //   const username = this.form.get('username').value;
  //   const password = this.form.get('password').value;
  //   const role = this.form.get('role').value;

  //   let loginDetails = {
  //     "username": username,
  //     "password": password,
  //     "role": role
  //   }

  //   this.masterService.add_user({
  //     "action": "SELECT"
  //     //  "role_id": 2
  //   }).subscribe((res: any) => {
  //     this.getAllUsersData = res['data'];
  //     this.userDetails = this.getAllUsersData;
  //     this.managersList = this.userDetails.filter((ele: any) => ele.role_id == 2)
  //     console.log('getAllUsers', this.getAllUsersData);

  //   })

  //   // this.masterService.login(username, password, role).subscribe({
  //   this.masterService.login(loginDetails).subscribe({
  //     next: (res) => {
  //       if (res?.status === 'success' && res?.data?.length > 0) {
  //         try {
  //           const result = JSON.parse(res.data[0].result);
  //           // let matchvalue = this.userDetails.find(user => user.role_id === result.role_id);
  //           let matchvalue = this.userDetails.find(user => user.username === username && user.role_id === result.role_id);
  //           sessionStorage.setItem('userDetails', JSON.stringify(matchvalue));


  //           let role = matchvalue.role_name;
  //           if (result.status === "Login Success") {
  //             // console.log(result.message || 'Login successful!');
  //             console.log(result.user_id || 'Login successful!');
  //             // this.notify.success(result.message || 'Login successful!');
  //             this.notify.success(`${username} Login successful!`);
  //             sessionStorage.setItem('username', username);
  //             sessionStorage.setItem('role', role);
  //             sessionStorage.setItem('user_id', result.user_id);
  //             this.menuService.setRole(role);

  //             // Use Promise.resolve or setTimeout for navigation
  //             // if (role === 'Manager') {
  //             //   Promise.resolve().then(() => this.router.navigate(['/dashboard-manager']));
  //             // } else if (role === 'Engineer') {
  //             //   Promise.resolve().then(() => this.router.navigate(['/dashboard-engineer']));
  //             // } else if (role === 'Admin') {
  //             //   Promise.resolve().then(() => this.router.navigate(['/dashboard-admin']));
  //             // }
  //             if (result.role_id == 2) {
  //               Promise.resolve().then(() => this.router.navigate(['/dashboard-manager']));
  //             } else if (result.role_id == 3) {
  //               Promise.resolve().then(() => this.router.navigate(['/dashboard-engineer']));
  //             } else if (result.role_id == 1) {
  //               Promise.resolve().then(() => this.router.navigate(['/dashboard-admin']));
  //             }
  //           } else {
  //             this.loginError = result.message || 'Invalid credentials. Please try again.';
  //             this.notify.danger(result.message || 'Invalid credentials. Please try again.');
  //           }
  //         } catch (error) {
  //           console.error('Error parsing response:', error);
  //           this.loginError = 'An error occurred while processing the response.';
  //           this.notify.danger('An error occurred while processing the response.');
  //         }
  //       } else {
  //         this.loginError = 'Invalid response from the server.';
  //         this.notify.danger('Invalid response from the server.');
  //       }
  //     },
  //     error: (err) => {
  //       console.error('An error occurred during login:', err);
  //       this.loginError = 'An error occurred while logging in. Please try again.';
  //     },
  //   });
  // }

  signUp() {
  if (this.form.invalid) {
    this.loginError = 'Please fill in all fields correctly.';
    return;
  }

  const username = this.form.get('username').value;
  const password = this.form.get('password').value;
  const role = this.form.get('role').value;

  const loginDetails = { username, password, role };

  // Step 1️⃣ — Fetch all users FIRST to avoid race condition
  this.masterService.add_user({ action: 'SELECT' }).subscribe({
    next: (res: any) => {
      this.getAllUsersData = res['data'];
      this.userDetails = this.getAllUsersData || [];
      this.managersList = this.userDetails.filter((ele: any) => ele.role_id == 2);
      console.log('getAllUsers', this.getAllUsersData);

      // Step 2️⃣ — Then call login API
      this.masterService.login(loginDetails).subscribe({
        next: (res) => {
          if (res?.status === 'success' && res?.data?.length > 0) {
            try {
              const parsedData = res.data?.[0]?.result;
              if (!parsedData) {
                throw new Error('Empty or missing result in response');
              }

              // Safe JSON parsing
              const result = typeof parsedData === 'string' ? JSON.parse(parsedData) : parsedData;

              // Ensure numeric comparison
              const matchvalue = this.userDetails.find(
                (user: any) =>
                  user.username === username &&
                  +user.role_id === +result.role_id
              );

         
              if (!matchvalue) {
                console.warn('User not found in userDetails for', username, result.role_id);
                this.loginError = 'User details not found. Please try again.';
                this.notify.danger('User details not found. Please try again.');
                return;
              }

              const userRoleName = matchvalue.role_name;
              sessionStorage.setItem('userDetails', JSON.stringify(matchvalue));

              if (result.status === 'Login Success') {
                this.notify.success(`${username} Login successful!`);
                sessionStorage.setItem('username', username);
                sessionStorage.setItem('role', userRoleName);
                sessionStorage.setItem('user_id', result.user_id);
                this.menuService.setRole(userRoleName);

                
                switch (+result.role_id) {
                  case 1:
                    Promise.resolve().then(() => this.router.navigate(['/dashboard-admin']));
                    break;
                  case 2:
                    Promise.resolve().then(() => this.router.navigate(['/dashboard-manager']));
                    break;
                  case 3:
                    Promise.resolve().then(() => this.router.navigate(['/dashboard-engineer']));
                    break;
                  default:
                    this.notify.warning('Unknown role detected.');
                    break;
                }
              } else {
                this.loginError = result.message || 'Invalid credentials. Please try again.';
                this.notify.danger(result.message || 'Invalid credentials. Please try again.');
              }
            } catch (error) {
              console.error('Error parsing response:', error, res);
              this.loginError = 'An error occurred while processing the response.';
              this.notify.danger('An error occurred while processing the response.');
            }
          } else {
            this.loginError = 'Invalid response from the server.';
            this.notify.danger('Invalid response from the server.');
          }
        },
        error: (err) => {
          console.error('An error occurred during login:', err);
          this.loginError = 'An error occurred while logging in. Please try again.';
          this.notify.danger('An error occurred while logging in. Please try again.');
        },
      });
    },
    error: (err) => {
      console.error('Error fetching user list:', err);
      this.loginError = 'Failed to fetch user list. Please try again.';
      this.notify.danger('Failed to fetch user list. Please try again.');
    },
  });
}

  signUp1() {


  }

  // password_show_hide() {
  //   // debugger
  //   var x = <HTMLInputElement>document.getElementById("password");
  //   var show_eye = <HTMLInputElement>document.getElementById("show_eye");
  //   var hide_eye = <HTMLInputElement>document.getElementById("hide_eye");
  //   hide_eye.classList.remove("d-none");
  //   if (x.type === "password") {
  //     x.type = "text";
  //     show_eye.style.display = "none";
  //     hide_eye.style.display = "block";
  //   } else {
  //     x.type = "password";
  //     show_eye.style.display = "block";
  //     hide_eye.style.display = "none";
  //   }
  // }
password_show_hide() {
  const passwordField = document.getElementById("password") as HTMLInputElement;
  const showEye = document.getElementById("show_eye") as HTMLElement;
  const hideEye = document.getElementById("hide_eye") as HTMLElement;

  if (passwordField.type === "password") {
    passwordField.type = "text";
    showEye.classList.add("d-none");
    hideEye.classList.remove("d-none");
  } else {
    passwordField.type = "password";
    showEye.classList.remove("d-none");
    hideEye.classList.add("d-none");
  }
}



  redirectToRegister() {
    const redirectUri = encodeURIComponent('http://localhost:4200');
    const url = `https://auth.suryojasvi.com/auth/realms/wyzminds/protocol/openid-connect/registrations?client_id=wyzminds-auth&response_type=code&scope=openid&redirect_uri=${redirectUri}`;
    window.location.href = url;
  }

  keycloakInit(){
    console.log("keycloak ==>>> ");
    this.ks.init()
     .then((authenticated:any) => {
      console.log('User is authenticated:', authenticated);
      return authenticated;
    }).catch((e) => {
      console.error('Keycloak initialization failed => ', e);
      return false;
    });
    
  }

  login(){
    console.log("KeycloakService => ", this.ks)
    this.ks.init()
     .then(authenticated => {
      console.log("Keycloak initialized:", authenticated, "this.kc => ", this.ks);
    })
    .catch(err => {
      console.error("Keycloak init failed", err);
    });
  
    
  }

   getToken() {
    console.log(this.ks.getToken())
  }

  getUsername() {
   console.log(this.ks.getUsername()) 
  }

  logout(){
   console.log(this.ks.logout())
  }
}
